var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoFilled = function SvgVideoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.724 18.264h8.493c.865 0 1.534-.234 2.006-.702.478-.462.717-1.117.717-1.966V7.667c0-.849-.228-1.504-.685-1.966-.45-.467-1.109-.701-1.974-.701H4.724c-.833 0-1.497.234-1.99.701C2.243 6.163 2 6.818 2 7.667v7.97c0 .854.236 1.504.71 1.95.477.45 1.149.677 2.014.677Zm12.393-4.062 2.772 2.394c.161.14.328.252.5.338.171.086.34.129.507.129.328 0 .594-.108.798-.322.204-.215.306-.5.306-.855V7.41c0-.354-.102-.636-.306-.846-.204-.215-.47-.322-.798-.322a1.13 1.13 0 0 0-.508.129 2.28 2.28 0 0 0-.5.338l-2.771 2.377v5.117Z",
    fill: "currentColor"
  })));
};
export default SvgVideoFilled;